import { ArrowButtonBase } from "@jog/react-components"

export const PrimaryButton = ArrowButtonBase({
    defaultBgColor: "#000",
    preIconShow: false,
    ArrowButtonWrapperCss: "py-2.5 px-12.5 font-primary font-normal text-xs",
})
